import { useRealTimeTypedQuery, useSelectedLocation } from "components";
import { useInterventionPendingChecklistsListeners } from "modules/PendingChecklistsDashboard/components/InterventionChecklists/listeners";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { InterventionKeywordPendingChecklist } from "models";

export type InterventionPendingChecklistsGrouped = {
  keyword: string;
  checklists: InterventionKeywordPendingChecklist[];
};

const groupInterventionPendingChecklists = (interventionPendingChecklists: InterventionKeywordPendingChecklist[]) => {
  const interventionPendingChecklistsGrouped: InterventionPendingChecklistsGrouped[] = [
    ...new Map(interventionPendingChecklists.map(ipc => [ipc.keyword, { keyword: ipc.keyword, checklists: [] }])).values()
  ];

  interventionPendingChecklists.forEach(ch => {
    const existingGroup = interventionPendingChecklistsGrouped.find(ds => ds.keyword === ch.keyword);
    if (existingGroup) existingGroup.checklists.push(ch);
  });

  return interventionPendingChecklistsGrouped
    .map(group => ({ ...group, checklists: group.checklists.sort((a, b) => a.ordering - b.ordering) }))
    .sort((a, b) => a.keyword.localeCompare(b.keyword));
};

export const useInterventionPendingChecklistsQuery = () => {
  const { selectedLocation } = useSelectedLocation();
  const listeners = useInterventionPendingChecklistsListeners();

  return useRealTimeTypedQuery({
    queryKey: PendingChecklistsQueryKeys.interventionPendingChecklists,
    queryFn: async ({ endpoint, baseUrl }) =>
      (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation?.id }, baseUrl)).data.intervention_keyword_pending_checklists,
    enabled: Boolean(selectedLocation?.id),
    select: groupInterventionPendingChecklists,
    refetchOnDependencies: [selectedLocation?.id],
    listeners
  });
};
